import { getQuerySort } from 'awokado/structs/query';

export default ({ getRoot }) => state => {
  const root = getRoot(state);

  return getQuerySort(root);
};
